import { inject, Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '@reducers/interfaces';
import { Observable } from 'rxjs';
import { combineLatestWith, filter, map } from 'rxjs/operators';

import { authState, isAuthenticated } from '../../reducers/auth/auth-service.selectors';

@Injectable()
export class TrialExpiredGuard {
  #store = inject<Store<AppState>>(Store);
  #router = inject(Router);

  canActivate(): Observable<UrlTree | boolean> {
    return this.#retrieveAuthenticatedStatus().pipe(
      map(([auth, authenticated]) => {
        if (!authenticated) {
          return this.#redirectToLogin();
        }

        if (auth.status !== 'expired' && auth.status !== 'planSelection') {
          return this.#redirectToDashboard();
        }

        return true;
      }),
    );
  }

  #retrieveAuthenticatedStatus() {
    return this.#store.select(authState).pipe(
      filter((auth) => !auth.loading),
      combineLatestWith(this.#store.select(isAuthenticated)),
    );
  }

  #redirectToLogin(): UrlTree {
    return this.#router.createUrlTree(['login']);
  }

  #redirectToDashboard(): UrlTree {
    return this.#router.createUrlTree(['dashboard']);
  }
}
